import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { Stack } from '@src/components';
import TimeSelectField from '@src/corelib/forms/generic/TimeSelectField';

import 'dayjs/locale/de';

function TimeFromField(props) {
  return <TimeSelectField label="From" name="acti_start_time" {...props} />;
}
function TimeToField(props) {
  return <TimeSelectField label="To" name="acti_end_time" {...props} />;
}

export default function TimeRangeField({onStartTimeBlur, onEndTimeBlur}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
      <Stack spacing={2} direction="row">
        <TimeFromField minutesStep={15} onBlur={onStartTimeBlur} />
        <TimeToField minutesStep={15} onBlur={onEndTimeBlur} />
      </Stack>
    </LocalizationProvider>
  );
}

